const find_modal = (state, dialog_type) => {
  let found = state.modals.find((modal)=> modal.type === dialog_type);
  if (!found) {
    console.error('Modal with name ' + dialog_type + ' not found');
  }
  return found;
};

export default {
  namespaced: true,
  state     : {
    modals: [
      {
        active     : false,
        type       : 'success',
        modal_title: 'Поздравляем! Тест удачно сдан.',
        modal_text : '',
      },
      {
        active     : false,
        type       : 'failed',
        modal_title: 'К сожалению, Вы не сдали тест.',
        modal_text : '',
      },
      {
        active     : false,
        type       : 'test',
        modal_title: 'Итоговый тест курса',
        modal_text : '',
      },
      {
        active     : false,
        type       : 'test_cancel',
        modal_title: '',
        modal_text : 'Прервать тест?',
      },

    ],
  },
  getters: {
    modal_success    : ({modals}) => modals.find( (modal) => modal.type === 'success'),
    modal_failed     : ({modals}) => modals.find( (modal) => modal.type === 'failed'),
    modal_test       : ({modals}) => modals.find( (modal) => modal.type === 'test'),
    modal_test_cancel: ({modals}) => modals.find( (modal) => modal.type === 'test_cancel'),
    get_by_active    : ({modals}) => modals.find( (modal) => modal.active === 'active'),
    test_modal_active: ({}, {modal_test}) => modal_test && modal_test.active,
  },
  mutations: {
    CLOSE_MODAL(state, dialog_type) {
      const found = find_modal(state, dialog_type);
      found.active = false;
    },
    OPEN_MODAL(state, dialog_type) {
      const found = find_modal(state, dialog_type);
      found.active = true;
    },
  },
};
